<template>
   <form @submit.prevent="update">
      <div class="modal-body modal-open modal-height-max modal-row2 profile-modal-body" style="max-height: 66vh" v-if="profile">
         <SectionCardComponent
            eyebrow="Perfil"
            title="Foto e identificação"
            subtitle="Atualize sua foto e os principais dados da sua conta."
            icon="icon-user"
            custom-class="profile-modal-section-card profile-modal-avatar-card">
            <div class="profile-modal-avatar-panel">
               <div class="avatar-size avatar profile-modal-avatar" v-if="widthPhone()">
                  <label for='avatar' class="pointer"><img class="user-avatar"
                                                           :src="imageCropped ? imageCropped : profile.avatar"></label>
                  <input type="file" id="avatar" accept="image/jpeg/*" @change="uploadImage()" style=" display: none;">
                  <div class="status pointer">
                     <label for='avatar'><i class="icon-camera camera"/></label>
                     <input type="file" id="avatar" accept="image/jpeg/*" @change="uploadImage()"
                            style=" display: none;">
                  </div>
               </div>
               <div class="avatar-size avatar profile-modal-avatar" v-if="!widthPhone()">
                  <img class="user-avatar" :src="imageCropped ? imageCropped : profile.avatar">
                  <div class="status pointer">
                     <label for='avatar'><i class="icon-camera camera"/></label>
                     <input type="file" id="avatar" accept="image/jpeg/*" @change="uploadImage()"
                            style=" display: none;">
                  </div>
               </div>
               <div class="profile-modal-avatar-copy">
                  <strong>{{ profile.name }}</strong>
                  <span>{{ profile.email }}</span>
               </div>
            </div>
         </SectionCardComponent>

         <SectionCardComponent
            eyebrow="Dados"
            title="Informações pessoais"
            subtitle="Dados usados para identificação e contato no sistema."
            icon="icon-info-with-circle"
            custom-class="profile-modal-section-card">
            <div class="row gutters">
               <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <div class="form-group">
                     <label for="name" class="required">{{ t('GENERAL.NAME') }}: </label>
                     <input data-cy="profile_update_modal_name" class="form-control" type="text" name="name" id="name"
                            placeholder="Digite o nome" v-model="profile.name" @keyup="inputName(profile.name)">
                     <div v-if="isNameInvalid" class="validation">{{ t(msgError) }}</div>
                  </div>
               </div>
               <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <div class="form-group">
                     <label for="email">{{ t('GENERAL.EMAIL') }}: </label>
                     <input data-cy="profile_update_modal_email" class="form-control" type="text" name="email" id="email"
                            v-model="profile.email" disabled>
                     <div v-if="isTaxpayerInvalid" class="validation">{{ t(msgTaxpayer) }}</div>
                  </div>
               </div>
               <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <div class="form-group">
                     <label for="taxpayer" class="required">{{ t('GENERAL.TAXPAYER') }}: </label>
                     <input data-cy="profile_update_modal_email" class="form-control" type="text" name="email"
                            id="taxpayer" v-model="profile.taxpayer"
                            v-mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']"
                     >
                     <div v-if="isTaxpayerInvalid" class="validation">{{ t(msgTaxpayer) }}</div>
                  </div>
               </div>
               <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12">
                  <div class="form-group">
                     <label for="creci">{{ t('GENERAL.CRECI') }}: </label>
                     <input data-cy="profile_update_modal_email" class="form-control" type="text" name="email" id="creci"
                            v-model="profile.creci">
                     <div v-if="isTaxpayerInvalid" class="validation">{{ t(msgTaxpayer) }}</div>
                  </div>
               </div>
               <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12">
                  <div class="form-group">
                     <label
                        for="birthdate">{{
                           (profile?.taxpayer?.length > 14) ? t('COMPANIES.BIRTHDATE_COMAPANY') : t('COMPANIES.BIRTHDATE')
                        }}:</label>
                     <input type="date" id="birthdate" name="birthdate" v-model="profile.birthday" class="form-control">
                  </div>
               </div>
            </div>
         </SectionCardComponent>

         <SectionCardComponent
            eyebrow="Contato"
            title="Telefones"
            subtitle="Mantenha ao menos um telefone cadastrado para contato."
            icon="icon-phone"
            custom-class="profile-modal-section-card">
            <div class="row gutters">
               <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <div class="form-group mb-0">
                     <phone v-if="profile.phones" :phonesIndex="profile.phones" :required="true"
                            @update="updatePhone($event)"></phone>
                  </div>
               </div>
            </div>
         </SectionCardComponent>

         <SectionCardComponent
            eyebrow="Preferências"
            title="Comunicação"
            subtitle="Defina se deseja receber novidades e comunicados da R2."
            icon="icon-mail"
            custom-class="profile-modal-section-card profile-modal-preferences-card">
            <div class="custom-control custom-switch profile-modal-switch">
               <input type="checkbox" class="custom-control-input" id="active" v-model="profile.accept_marketing">
               <label data-cy="profile_update_about_r2" class="custom-control-label"
                      for="active">{{ t('USERS.ACCEPT_RECEIVE_NEWS_ABOUT_R2') }}</label>
            </div>
         </SectionCardComponent>
      </div>
      <div class="modal-footer justify-content-right">
         <button data-cy="profile_update_modal_close" class="btn btn-secondary" data-dismiss="modal" type="button"
                 @click="closeFirstModal()">{{ t('ACTIONS.CLOSE') }}
         </button>
         <button data-cy="profile_update_modal_confirm" class="btn btn-primary" type="submit">{{
               t('ACTIONS.CONFIRM')
            }}
         </button>
      </div>
   </form>
</template>

<script>

import {mapState} from 'vuex';
import {useI18n} from 'vue-i18n';
import User from '@/services/user';
import {useToast} from "vue-toastification";
import Validate from '@/components/validate.vue';
import phone from '@/components/layouts/phoneComponent.vue';
import SectionCardComponent from '@/components/layouts/SectionCardComponent.vue';

export default {
   name: 'profileModal',
   props: ['profileIndex'],
    mixins: [Validate],
    components: {
      SectionCardComponent,
      phone,
    },

   setup() {
      const {t} = useI18n();
      const toast = useToast();
      return {t, toast}
   },

   computed: {
      ...mapState({
         imageCropped: 'imageCropped',
      }),
   },

   data() {
      return {
         profile: null,
      }
   },
    emits:['update'],
   mounted() {
      this.profile = this.profileIndex;
   },

   watch: {
      profileIndex: function () {
         this.profile = this.profileIndex;
      }
   },

   methods: {
      update() {
         this.invalid = [];
          if (!this.profile?.taxpayer){
              this.toast.error('CPF/CNPJ obrigatório')
          }
         if (this.checkForm()) {
             if (!this.profile?.taxpayer){
                 return
             }
            this.$store.commit('changeLoading', true);

            if (this.imageCropped) {
               this.profile.avatar = this.imageCropped;
            }

            User.update(this.profile).then(() => {
               this.$store.dispatch('ActionRefreshToken');
               document.getElementById('closeProfile').click();
               this.toast.success(this.t('GENERAL.MSG.UPDATE_SUCCESS'));

               this.$emit('update');

               this.$store.commit('changeLoading', false);
            }).catch(error => {
               this.$store.commit('changeLoading', false);
               this.errorMsg(error);
            });
         }
      },

      checkForm() {
         this.nameValidate(this.profile.name);

         if (!this.profile.phones[0]) {
            this.toast.error(this.t('GENERAL.MSG.ADD_ONE_PHONE'), {timeout: false})
            return false;
         }

         if (this.invalid.length && this.invalid.length > 0) {
            return false;
         }
         return true;
      },

      uploadImage() {
         const file = document.querySelector('input[type=file]').files[0]
         const reader = new FileReader()

         reader.onloadend = () => {
            this.isCropping = true;
            this.$store.commit('setImage', reader.result);
            document.getElementById('imageCropper').click();
         }

         reader.readAsDataURL(file);
      },

      updatePhone(phones) {
         this.profile.phones = phones;
      },

      closeFirstModal() {
         if (localStorage.getItem('firstProfileClosed') == "true") {
            this.$emit('update');
            localStorage.setItem('firstProfileClosed', false);
         }
      }
   }
}
</script>

<style scoped>
.profile-modal-body {
   padding: 0 1rem 1rem !important;
}

.profile-modal-section-card {
   margin-bottom: 12px !important;
}

.profile-modal-avatar-panel {
   align-items: center;
   background: rgba(231, 244, 240, 0.52);
   border: 1px solid rgba(14, 94, 78, 0.08);
   border-radius: 14px;
   display: flex;
   gap: 1rem;
   padding: 0.9rem 1rem;
}

.profile-modal-avatar {
   flex: 0 0 auto;
   margin: 0 !important;
}

.profile-modal-avatar-copy {
   display: flex;
   flex-direction: column;
   min-width: 0;
}

.profile-modal-avatar-copy strong {
   color: #173b34;
   font-size: 1rem;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}

.profile-modal-avatar-copy span {
   color: #6b7c78;
   font-size: 0.82rem;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}

.profile-modal-preferences-card {
   padding-bottom: 16px !important;
}

.profile-modal-switch {
   align-items: center;
   background: rgba(231, 244, 240, 0.52);
   border: 1px solid rgba(14, 94, 78, 0.08);
   border-radius: 12px;
   display: flex;
   min-height: 46px;
   padding: 0.75rem 1rem 0.75rem 3rem;
}

.profile-modal-switch .custom-control-label {
   color: #173b34;
   font-weight: 700;
}

:global(html.dark-theme .profile-modal-avatar-panel),
:global(html.dark-theme .profile-modal-switch) {
   background: var(--dark-primary-soft) !important;
   border-color: var(--dark-border) !important;
}

:global(html.dark-theme .profile-modal-avatar-copy strong),
:global(html.dark-theme .profile-modal-switch .custom-control-label) {
   color: var(--dark-text) !important;
}

:global(html.dark-theme .profile-modal-avatar-copy span) {
   color: var(--dark-text-soft) !important;
}

@media (max-width: 575px) {
   .profile-modal-avatar-panel {
      align-items: center;
      flex-direction: column;
      text-align: center;
   }

   .profile-modal-avatar-copy {
      max-width: 100%;
   }
}
</style>
